import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollProgress from "@/components/ScrollProgress";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ThemeProvider } from "@/context/ThemeContext";

import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Doctors from "@/pages/Doctors";
import Solutions from "@/pages/Solutions";
import HowItWorks from "@/pages/HowItWorks";
import Pricing from "@/pages/Pricing";
import Security from "@/pages/Security";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import RequestDemo from "@/pages/RequestDemo";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import Seo from "@/components/Seo";
import { APP_URL } from "@/lib/urls";

function ScrollToTop() {
  const { pathname } = useLocation();
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    const isSolutionsTransition =
      previousPath.startsWith("/solutions") && pathname.startsWith("/solutions");
    previousPathRef.current = pathname;
    if (isSolutionsTransition) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function RedirectToApp() {
  useEffect(() => {
    window.location.replace(APP_URL);
  }, []);
  return null;
}

/** Legacy HMC deep links that land on the marketing site (QR / bookmarks). */
function RedirectLabcaseToHmc() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    window.location.replace(`${APP_URL}${pathname}${search}${hash}`);
  }, [pathname, search, hash]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Seo />
          <ScrollProgress />
          <Navbar />
          <main data-testid="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/features" element={<Features />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/:slug" element={<Solutions />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/security" element={<Security />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/request-demo" element={<RequestDemo />} />
              <Route path="/sign-in" element={<RedirectToApp />} />
              <Route
                path="/admin/labcase/*"
                element={<RedirectLabcaseToHmc />}
              />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </SmoothScroll>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
